import { useContext } from 'react';
import { UploadContext } from '..';
export function useUpload() {
  var fileUpload = useContext(UploadContext);

  if (fileUpload === null) {
    throw new Error('useUpload must under RcUpload');
  }

  return fileUpload;
}